import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "conversations-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin h-5 w-5 mr-2 text-gray-700",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
  })
], -1)

import { CustomerSession } from '@/http/customerSession';
import { computed, PropType, ref, onUnmounted } from 'vue';
import ConverzaSessionResume from './ConverzaSessionResume.vue';
import { set } from '@vueuse/core';
import { RETRIEVE_SESSIONS, RetrieveSessionParameters } from '@/store';
import { useStore } from 'vuex';
import EmptySessions from './EmptySessions.vue';


const POLLING_INTERVAL_IN_SECONDS = 5;

export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollableSessions',
  props: {
    sessions: {
        type: Object as PropType<CustomerSession[]>,
        required: true,
    },
    mine: {
        type: Boolean,
        required: false,
        default: false,
    },
    currentTab: {
        type: String,
        required: true
    }
},
  emits: ['TOGGLE_TAB'],
  setup(__props) {

const hasReachedLastSession = ref<boolean | undefined>(undefined);
const canLoadMore = ref(true);
const isLoadingMore = ref(false);
const store = useStore();


const props = __props;

const loadMoreSessions = async (parameters: RetrieveSessionParameters) => {
    const last = await store.dispatch(RETRIEVE_SESSIONS, parameters);

    set(hasReachedLastSession, last);
};

const tryLoadMore = async () => {
    set(canLoadMore, false);
    set(isLoadingMore, true);

    const filter = {
        mine: props.mine === true ? true : false,
        itemsPerPage: 10
    };

    await loadMoreSessions(filter);

    set(canLoadMore, true);

    setTimeout(() => {
        set(isLoadingMore, false);
    }, 500);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onInfiniteTabScroll = async (event: any) => {
    let isInfiniteScrolling = ((event?.target?.clientHeight ?? 0) + (event?.target?.scrollTop ?? 0)) >= (document.getElementById('conversations-wrapper')?.scrollHeight ?? 0);
    if (isInfiniteScrolling && canLoadMore.value === true && hasReachedLastSession.value !== true) {
        await tryLoadMore();
    }
};

const isEmpty = computed(() => {
    return (props.sessions.length ?? 0) === 0;
});

const poll = async () => {
    const filter = {
        page: 0,
        mine: props.mine === true ? true : false,
        itemsPerPage: 10,
    };
    await loadMoreSessions(filter);
};

const interval = setInterval(async () => await poll(), POLLING_INTERVAL_IN_SECONDS * 1000);

onUnmounted(() => clearInterval(interval));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "overflow-y-auto max-h-full",
    onScroll: onInfiniteTabScroll
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sessions, (session) => {
        return (_openBlock(), _createBlock(ConverzaSessionResume, {
          class: "",
          key: session.id,
          session: session,
          onTOGGLE_TO_ANSWER_CHAT: _cache[0] || (_cache[0] = () => _ctx.$emit('TOGGLE_TAB'))
        }, null, 8, ["session"]))
      }), 128))
    ]),
    _createVNode(EmptySessions, {
      class: _normalizeClass({
            hidden: isEmpty.value === false
        })
    }, null, 8, ["class"]),
    _createElementVNode("span", {
      class: _normalizeClass([{
                invisible: isLoadingMore.value === false
            }, "flex items-center justify-center px-4 py-2 text-gray-400 font-semibold opacity-50"])
    }, [
      _hoisted_2,
      _createTextVNode(" Carregando mais Conversas ")
    ], 2)
  ], 32))
}
}

})